export const getCurrentTime = (date) => {
  const hours = new Date().getHours() <= 9 ? `0${new Date().getHours()}` : new Date().getHours();
  const minutes = new Date().getMinutes() <= 9 ? `0${new Date().getMinutes()}` : new Date().getMinutes();
  return `${hours}:${minutes}`;
};

export const getCurrentDate = () => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return mm + "/" + dd + "/" + yyyy;
};

export const getTime = (data) => {
  const date = data.toDate();
  const hours = date.getHours() <= 9 ? `0${date.getHours()}` : date.getHours();
  const minutes = date.getMinutes() <= 9 ? `0${date.getMinutes()}` : date.getMinutes();
  return `${hours}:${minutes}`;
};

export const getDate = (data) => {
  const today = data.toDate();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = today.getFullYear();
  return mm + "/" + dd + "/" + yyyy;
};
export function formatDate(date, format) {
  const options = {
    day: "numeric",
    month: "numeric",
    year: "numeric",
  };

  return new Intl.DateTimeFormat("en-GB", options)
    .formatToParts(date)
    .map((part) => {
      switch (part.type) {
        case "day":
          return part.value.padStart(2, "0");
        case "month":
          return part.value.padStart(2, "0");
        case "year":
          return part.value;
        default:
          return part.value;
      }
    })
    .join(format);
}

export function sitemapFormatDate(dateString) {
  // Split the date string into components
  const parts = dateString.split("/");

  // Create a new Date object with the given components
  const date = new Date(`${parts[2]}-${parts[0]}-${parts[1]}`);

  // Extract the year, month, and day
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Adding 1 to month since it's zero-based
  const day = String(date.getDate()).padStart(2, "0");

  // Return the formatted date string
  return `${year}-${month}-${day}`;
}

export function formatDateIntoString(inputDate) {
  // Split the input date string into month, day, and year
  const [month, day, year] = inputDate.split("/");

  // Create a Date object with the provided year, month (subtract 1 as months are zero-based), and day
  const date = new Date(year, month - 1, day);

  // Define an array to map month numbers to month names
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the month name from the months array
  const monthName = months[date.getMonth()];

  // Get the day suffix (e.g., 1st, 2nd, 3rd, 4th, etc.)
  let daySuffix;
  switch (day % 10) {
    case 1:
      daySuffix = day == 11 ? "th" : "st";
      break;
    case 2:
      daySuffix = day == 12 ? "th" : "nd";
      break;
    case 3:
      daySuffix = day == 13 ? "th" : "rd";
      break;
    default:
      daySuffix = "th";
  }

  // Construct the formatted date string (e.g., "6th May, 2024")
  const formattedDate = `${parseInt(day)}${daySuffix} ${monthName}, ${year}`;

  return formattedDate;
}
